import { ListenerMiddlewareInstance, createListenerMiddleware } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '@/stores/types'

export const listenerMiddleware = createListenerMiddleware()

const instance = listenerMiddleware as ListenerMiddlewareInstance<RootState, AppDispatch>
